import { apiNoLoading, IDataRequest, IDataResponse } from "src/framework/providers/api";
import AProvider from "src/framework/providers/AProvider";


export type IProjetosComponentesRestricoes = {
    componente_id: number;
    restricoes: string[]
}

class ProjetosComponentesProvider extends AProvider {
    constructor() {
        super("/projetos/componentes");
    }

    async verificarRestricoesProjeto(idProjeto: number, apiInstance = apiNoLoading): Promise<IDataResponse<IProjetosComponentesRestricoes[]>> {
        if (!idProjeto) {
            return {
                data: [],
                statusCode: 400,
                message: "ID do projeto não informado"
            }
        }
        
        const request: IDataRequest = {
            url: `${this.path}/verificar_restricoes/${idProjeto}`,
        }

        return await apiInstance.get(request);
    }
}

export { ProjetosComponentesProvider }